import {
  languageBuilder
} from "./builder.js";
const anime_airing = {
  UNIT_SINGULAR: `show`,
  UNIT_PLURAL: `shows`,
  UNIT_SHORT: `Show`,
  SUBUNIT_SINGULAR: `episode`,
  SUBUNIT_PLURAL: `episodes`,
  SUBUNIT_SHORT: `Ep.`,
  SUBUNIT_VERB_FUTURE: `airs`,
  SUBUNIT_VERB_PAST: `aired`
};
const anime_bluray = {
  UNIT_SINGULAR: `show`,
  UNIT_PLURAL: `shows`,
  UNIT_SHORT: `Show`,
  SUBUNIT_SINGULAR: `volume`,
  SUBUNIT_PLURAL: `volumes`,
  SUBUNIT_SHORT: `Vol.`,
  SUBUNIT_VERB_FUTURE: `drops`,
  SUBUNIT_VERB_PAST: `published`
};
const manga_chapter = {
  UNIT_SINGULAR: `manga`,
  UNIT_PLURAL: `manga`,
  UNIT_SHORT: `Manga`,
  SUBUNIT_SINGULAR: `chapter`,
  SUBUNIT_PLURAL: `chapters`,
  SUBUNIT_SHORT: `Ch.`,
  SUBUNIT_VERB_FUTURE: `drops`,
  SUBUNIT_VERB_PAST: `published`
};
const manga_volume = {
  UNIT_SINGULAR: `manga`,
  UNIT_PLURAL: `manga`,
  UNIT_SHORT: `Manga`,
  SUBUNIT_SINGULAR: `volume`,
  SUBUNIT_PLURAL: `volumes`,
  SUBUNIT_SHORT: `Vol.`,
  SUBUNIT_VERB_FUTURE: `drops`,
  SUBUNIT_VERB_PAST: `published`
};
const strings = {
  ALL_COMPLETE: `All projects are complete!`,
  CONNECTION_ERROR: `Connection error`,
  CONFIG_HEADER: `Configuration`,
  WEBSITE_SETTINGS_HEADER: `Website Settings`,
  APP_URL: `Your application URL`,
  LINK_PAGE: `Go to page`,
  PAGE_BGCOLOR: `Main site background color`,
  NO_COLOR: `Ignore background color`,
  RECOMMENDED_BGCOLOR: `Recommended background color`,
  OVERRIDE_BGCOLOR: `Override recommendation`,
  THEME_HEADER: `Theme Choice`,
  THEME_LIGHT: `Light`,
  THEME_DARK: `Dark`,
  SIZE_HEADER: `Size Choice`,
  SIZE_SMALL: `Small (not recommended)`,
  SIZE_NORMAL: `Normal`,
  ACCENT_HEADER: `Accent Color`,
  ACCENT_RED: `Red`,
  ACCENT_YELLOW: `Yellow`,
  ACCENT_GREEN: `Green`,
  ACCENT_BLUE: `Blue`,
  ACCENT_INDIGO: `Indigo`,
  ACCENT_PURPLE: `Purple`,
  ACCENT_PINK: `Pink`,
  ACCENT_NONE: `None`,
  LANGUAGE_HEADER: `Language`,
  EMBED_HEADER: `Wordpress Embed Code`,
  EMBED_DESCRIPTION: `Resize the iframe after page load`,
  EMBED_SHOW: `Show embed code`,
  EMBED_HIDE: `Hide embed code`,
  ALL_POSITIONS: `All Staff Positions`,
  EXAMPLE_ERROR: `This is an example error`,
  EXAMPLE_STATUS: `This is an example optional status message`,
  UNIT_JOINT_WITH: `Joint with {0}`,
  UNIT_SHOW_LESS: `Show less`,
  UNIT_SHOW_LESS_PLURAL: void 0,
  UNIT_SHOW_REMAINDER_SINGULAR: `Show {1} more %SUBUNIT_SINGULAR%...`,
  UNIT_SHOW_REMAINDER_PLURAL: `Show {1} more %SUBUNIT_PLURAL%...`,
  UNIT_UPDATED: `Updated {2}`,
  SUBUNIT_NOT_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_FUTURE% {1}`,
  SUBUNIT_WAS_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_PAST% {1}`,
  SUBUNIT_TO_RELEASE: `%SUBUNIT_SHORT% {0} to be released`,
  SUBUNIT_IN_PROGRESS: `%SUBUNIT_SHORT% {0} requires {2}`,
  SUBUNIT_NO_PROGRESS: `(no progress yet)`
};
import en from "../../_snowpack/pkg/javascript-time-ago/locale/en.json.proxy.js";
const lang = {
  locale: en,
  strings
};
export default {
  anime_airing: languageBuilder(lang, anime_airing),
  anime_bluray: languageBuilder(lang, anime_bluray),
  manga_chapter: languageBuilder(lang, manga_chapter),
  manga_volume: languageBuilder(lang, manga_volume)
};
//# sourceMappingURL=en.js.map
